













import BaseComponent from '@/components/base-component.vue';
import RulesEngineOverridesFilterList from '@/components/rules-engine/rule-override/filter-list.vue';
import RulesEngineOverridesList from '@/components/rules-engine/rule-override/list.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {
    RulesEngineOverridesFilterList,
    RulesEngineOverridesList,
    PermissionAuth,
  },
})
export default class RulesEngineOverrides extends BaseComponent {
  @Prop()
  public rule?: any;

  @Prop()
  public itemChanged?: any;

  public filter: any = {
    rule: {},
    referenceType: null,
    clientUnit: null,
    doctor: null,
    team: null,
  };

  public onFilter(filter): void {
    this.filter = filter;
  }

  public onChangeSatusItem(item, newStatus) {
    this.$emit('changeStatus', item, newStatus);
  }

  public onAfterSave() {
    this.$emit('afterSave');
  }
}
